import React, { useContext } from 'react';
import { cloneDeep } from 'lodash';
import { assign } from 'xstate';

import { BaseComponent } from '../Component';
import { SendContext } from '../../SendContext';
import { MachineContext } from '../../MachineContext';

import styles from './Mood.module.css';
import { MoodEnum } from './MoodEnum';

export interface MoodInputComponent extends BaseComponent {
  type: 'moodInput';
  props: MoodInputProps;
}
export interface MoodInputProps {
  saveResultTo: string;
}
export const MoodInput: React.FC<MoodInputProps> = ({ saveResultTo }) => {
  const { send } = useContext(SendContext);
  return (
    <div className={styles['input']}>
      {Object.values(MoodEnum).map((mood: MoodEnum, index) => {
        return (
          <div
            key={index}
            onClick={() => {
              send({
                type: 'writeToContext',
                payload: { [saveResultTo]: mood },
              });
              send({ type: mood.toLowerCase() });
            }}
            className={`${styles['moodIcon']} ${styles[mood]}`}
          />
        );
      })}
    </div>
  );
};

export const renderMoodInputAction = assign(
  (context: MachineContext, _event, actionMetadata) => {
    const newContext = cloneDeep(context);
    newContext.widgetData = newContext.widgetData.filter(
      (element) => !element.temporary
    );
    newContext.widgetData.push({
      type: 'moodInput',
      temporary: actionMetadata.action.temporary ?? false,
      props: {
        saveResultTo: actionMetadata.action.payload.saveResultTo,
      },
    });
    return newContext;
  }
);
